export enum ListedStatusEnum {
  MINTED = 'MINTED',
  LISTING_STARTED = 'LISTING_STARTED',
  LISTING_FAILED = 'LISTING_FAILED',
  LISTED = 'LISTED',
  DELIST_STARTED = 'DELIST_STARTED',
  DELIST_FAILED = 'DELIST_FAILED',
  DELISTED = 'DELISTED',
  ORDER_STARTED = 'ORDER_STARTED',
  ORDER_COMPLETED = 'ORDER_COMPLETED',
  ORDER_FAILED = 'ORDER_FAILED',
}

export enum BidStatusEnum {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED',
  RETRACTED = 'RETRACTED',
}

export enum OrderStatusEnum {
  CREATED = 'CREATED',
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  CANCELLED = 'CANCELLED',
  ORDER_SHIPPED = 'ORDER_SHIPPED',
  ORDER_DELIVERED = 'ORDER_DELIVERED',
  OWNERSHIP_TRANSFER_STARTED = 'OWNERSHIP_TRANSFER_STARTED',
  OWNERSHIP_TRANSFER_COMPLETED = 'OWNERSHIP_TRANSFER_COMPLETED',
  OWNERSHIP_TRANSFER_FAILED = 'OWNERSHIP_TRANSFER_FAILED',
  ORDER_UNDELIVERED = 'ORDER_UNDELIVERED',
  ORDER_SUCCESS = 'ORDER_SUCCESS',
  RETURN = 'RETURN',
  RETURN_SHIPPED = 'RETURN_SHIPPED',
  RETURN_DELIVERED = 'RETURN_DELIVERED',
  RETURN_UNDELIVERED = 'RETURN_UNDELIVERED',
  REFUND = 'REFUND',
  REFUND_COMPLETED = 'REFUND_COMPLETED',
  REFUND_FAILED = 'REFUND_FAILED',
  ONGOING = 'ON_GOING',
  COMPLETED = 'COMPLETED',
}
